import { sendEvent } from '../utils';

export interface AbTestGaEvent {
    event: 'abtest';
    experiment_name: string;
    experiment_variant: string;
}

const debounceMap = new Map<string, ReturnType<typeof setTimeout>>();

/**
 * Ensures that events are debounced independently for each experiment_name.
 */
const debouncedSendEvent = (event: AbTestGaEvent, delay: number = 300) => {
    // Clear any existing timeout for this experiment_name
    if (debounceMap.has(event.experiment_name)) {
        clearTimeout(debounceMap.get(event.experiment_name));
    }

    // Set a new timeout for this experiment_name
    const timeout = setTimeout(() => {
        sendEvent<AbTestGaEvent>(event);
        debounceMap.delete(event.experiment_name); // Clean up after sending
    }, delay);

    debounceMap.set(event.experiment_name, timeout);
};

/**
 * experiment_name: Name of experiment
 * experiment_variant: Normal variant should always be A
 */
const userInteraction = (experiment_name: string, experiment_variant: string, delay?: number) => {
    if (delay !== undefined) {
        debouncedSendEvent(
            {
                event: 'abtest',
                experiment_name,
                experiment_variant,
            },
            delay,
        );
    } else {
        sendEvent<AbTestGaEvent>({
            event: 'abtest',
            experiment_name,
            experiment_variant,
        });
    }
};

const AbTestTracking = {
    userInteraction,
};
export default AbTestTracking;
